/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Duration_TitleInputs */

const en_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const fr_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree`)
};

const de_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const it_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata`)
};

const ru_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность`)
};

const es_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const zh_cn2_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期间`)
};

const ja_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間隔`)
};

const hi_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_summary_duration_title = /** @type {(inputs: Summary_Duration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Summary_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_duration_title = /** @type {((inputs?: Summary_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_duration_title(inputs)
	if (locale === "de") return de_summary_duration_title(inputs)
	if (locale === "it") return it_summary_duration_title(inputs)
	if (locale === "ru") return ru_summary_duration_title(inputs)
	if (locale === "es") return es_summary_duration_title(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_duration_title(inputs)
	if (locale === "ja") return ja_summary_duration_title(inputs)
	if (locale === "hi") return hi_summary_duration_title(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_duration_title(inputs)
	return en_summary_duration_title(inputs)
});